@if (open()) {
  <div class="fixed inset-0 z-50 flex" role="presentation">
    <button
      type="button"
      class="min-h-0 flex-1 cursor-default border-0 bg-black/40 p-0"
      (click)="close()"
      @fadeBackdrop
      aria-label="Close notifications backdrop"
    ></button>

    <section
      #drawerPanel
      @slidePanel
      class="flex h-full w-full max-w-md flex-col bg-white shadow-xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="notification-drawer-title"
      aria-describedby="notification-drawer-desc"
    >
      <header class="relative border-b border-gray-100 px-6 pb-4 pt-6">
        <button
          type="button"
          data-notification-drawer-close
          class="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-red-50 text-red-500 transition hover:bg-red-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500"
          (click)="close()"
          aria-label="Close notifications"
        >
          <span aria-hidden="true" class="text-lg leading-none">×</span>
        </button>
        <h2
          id="notification-drawer-title"
          class="text-lg font-bold text-slate-900 pr-12"
        >
          Notification
        </h2>
        <p id="notification-drawer-desc" class="mt-1 text-sm text-gray-400">
          @if (store.loading()) {
            Loading notifications…
          } @else if (store.error()) {
            Couldn’t load notifications.
          } @else if (!store.hasNotifications()) {
            You’re all caught up. New alerts will appear here when you need to
            act.
          } @else {
            Review and respond to your pending notifications.
          }
        </p>
      </header>

      <div
        class="min-h-0 flex-1 overflow-y-auto px-6"
        role="region"
        aria-live="polite"
        [attr.aria-busy]="
          store.loading() || store.loadingMore() ? 'true' : 'false'
        "
        [attr.aria-label]="'Notification list, ' + store.notifications().length + ' items'"
      >
        @if (store.loading()) {
          <div class="space-y-4 py-4" aria-hidden="true">
            @for (i of [1, 2, 3]; track i) {
              <div class="flex gap-4">
                <div
                  class="h-10 w-10 shrink-0 animate-pulse rounded-lg bg-emerald-50"
                ></div>
                <div class="flex-1 space-y-2">
                  <div class="h-3 w-24 animate-pulse rounded bg-gray-200"></div>
                  <div class="h-4 w-full animate-pulse rounded bg-gray-200"></div>
                  <div class="h-3 w-40 animate-pulse rounded bg-gray-100"></div>
                </div>
                <div class="h-5 w-16 animate-pulse rounded bg-gray-200"></div>
              </div>
            }
          </div>
        } @else if (store.error()) {
          <p class="py-8 text-center text-sm text-red-600" role="alert">
            {{ store.error() }}
          </p>
        } @else if (!store.hasNotifications()) {
          <div
            class="flex min-h-[14rem] flex-col items-center justify-center px-2 py-10 text-center"
            role="status"
          >
            <div class="notification-drawer-empty-art">
              <lib-empty-state />
            </div>
            <h3 class="mt-6 text-base font-semibold text-slate-900">
              No notifications yet
            </h3>
            <p class="mt-2 max-w-sm text-sm leading-relaxed text-gray-500">
              When you have chargeback or other alerts, they will show up in this
              list.
            </p>
          </div>
        } @else {
          @for (n of store.notifications(); track n.id) {
            <app-notification-item
              [notification]="n"
              (onAccept)="onAccept($event)"
              (onDecline)="onDecline($event)"
            />
          }
          @if (store.loadMoreError()) {
            <p class="py-2 text-center text-sm text-red-600" role="alert">
              {{ store.loadMoreError() }}
            </p>
          }
          @if (store.canShowMore()) {
            <div class="sticky bottom-0 border-t border-gray-100 bg-white py-4">
              <button
                type="button"
                class="flex w-full min-h-11 items-center justify-center rounded-md border border-[#1a2b6d] px-4 text-sm font-medium text-[#1a2b6d] transition hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1a2b6d] disabled:cursor-not-allowed disabled:opacity-60"
                (click)="store.loadMoreNotifications()"
                [disabled]="store.loadingMore()"
                aria-label="Load more notifications"
              >
                @if (store.loadingMore()) {
                  <span
                    class="inline-block size-4 animate-spin rounded-full border-2 border-[#1a2b6d] border-t-transparent"
                    aria-hidden="true"
                  ></span>
                  <span class="ml-2">Loading…</span>
                } @else {
                  Show more
                }
              </button>
            </div>
          }
        }
      </div>
    </section>
  </div>
}
